/**
 * Extracts a meaningful error message from an HTTP error response.
 * Handles Pydantic validation errors (array of {loc, msg}) and plain string errors.
 */

const FIELD_LABELS: Record<string, string> = {
  name: 'Name',
  botanical_name: 'Botanical Name',
  melting_point: 'Melting Point',
  texture: 'Texture',
  pregnancy: 'Pregnancy',
  children: 'Children',
  shelf_life: 'Shelf Life',
  comedogenic_rating: 'Comedogenic Rating',
  key_fatty_acids: 'Key Fatty Acids',
  vitamins: 'Vitamins',
  carrier_oil_ratio: 'Carrier Oil Ratio',
  properties: 'Properties',
  best_for: 'Best For',
  aroma: 'Aroma',
  colour: 'Colour',
  cost_aud: 'Cost (AUD)',
  notes: 'Notes',
  cautions: 'Cautions',
  skin_type_other: 'Skin Type (other)',
  mes_notes: 'My Notes',
  stock_count: 'Stock Count',
  source: 'Source',
  type: 'Type',
  vegan: 'Vegan',
  mixing_ratio_firm: 'Ratio (Firm)',
  mixing_ratio_standard: 'Ratio (Standard)',
  mixing_ratio_soft: 'Ratio (Soft)',
  blending_family: 'Blending Family',
  usage_rate: 'Usage Rate',
  solubility: 'Solubility',
  mechanism: 'Mechanism',
  inci_name: 'INCI Name',
};

export function formatApiError(err: any): string {
  const detail = err?.error?.detail;

  // Pydantic validation errors: array of {loc: [...], msg: string}
  if (Array.isArray(detail)) {
    return detail.map((d: any) => {
      const rawField = Array.isArray(d.loc)
        ? d.loc.filter((p: string) => p !== 'body').join('.')
        : '';
      const label = FIELD_LABELS[rawField] || formatFieldName(rawField);
      const msg = d.msg || 'Invalid value';
      return label ? `${label}: ${msg}` : msg;
    }).join('\n');
  }

  // Plain string detail
  if (typeof detail === 'string') return detail;

  // Fallback
  return err?.message || err?.statusText || 'An unexpected error occurred';
}

function formatFieldName(field: string): string {
  if (!field) return '';
  return field
    .replace(/_/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase());
}
